import AboutMe from "../components/AboutMe";
import Footer from "../components/Footer";
import Header from "../components/Header";
import PorjectsSection from "../components/PorjectsSection";
import SocialLinks from "../components/SocialLinks";
import TechnologiesSlider from "../components/TechnologiesSlider";
import TimeLine from "../components/TimeLine";
import logo from '../Images/Assets/personalPhoto.png';

const HomePage = () => {
    return (
        <div className="HomePage">
            <Header />
            <div className="websiteTop">  
              <AboutMe />
              <img src={logo} alt="Mohamad Mourad" className="personalImage"/>
            </div>
            <SocialLinks />
            <TechnologiesSlider />
            <TimeLine />
            <PorjectsSection />
            <Footer />
        </div>
    );
}
 
export default HomePage;